<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable width="1200px" persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          {{ $t("NewUpdate.announ2") }}
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            style="float: right"
            @click="Fn_Close()"
          >
            {{ $t("consentform.close") }}</v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <br />
        <v-card-text class="pa-1">
          <v-data-table
            :headers="headers"
            :items="DataList"
            hide-default-footer
            :items-per-page="rowPerpage"
            :page.sync="Page"
            @page-count="PageCount = $event"
            class="pa-5"
          >
            <template v-slot:[`item.SendStatus`]="{ item }">
              <v-chip color="green" dark v-if="item.SendStatus === 'OK'">{{
                $t("onechat.status4")
              }}</v-chip>
              <v-chip color="error" dark v-else-if="item.SendStatus === 'ER'">{{
                $t("onechat.status3")
              }}</v-chip>
              <v-chip
                color="warning"
                dark
                v-else-if="item.SendStatus === 'WAIT'"
                >{{ $t("onechat.status7") }}</v-chip
              >
              <v-chip
                color="indigo"
                dark
                v-else-if="item.SendStatus === 'Read'"
                >{{ $t("onechat.status5") }}</v-chip
              >
            </template>
            <template v-slot:[`item.ErrorMessage`]="{ item }">
              <div class="red--text">{{ item.ErrorMessage }}</div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="mb-5">
          <v-layout row wrap justify-center align-center>
            <v-flex xs11 lg11 md11 sm11>
              <v-pagination
                total-visible="10"
                circle
                color="#077893"
                v-model="Page"
                :length="PageCount"
              >
              </v-pagination>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["show", "_detail"],
  data: function () {
    return {
      Page: 1,
      PageCount: 0,
      rowPerpage: 10,
      btnSendLoading: false,
      DataList: [],
      serviceEmail: "",
    };
  },
  created() {},
  computed: {
    ...mapGetters(["DataGroupConsent"]),
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    _profile: {
      get() {
        return this.$store.getters.profile;
      },
    },
    _apiKey: {
      get() {
        return this.$store.getters.apikey;
      },
    },
    _accesskey: {
      get() {
        return this.$store.getters.accessKey;
      },
    },
    headers: {
      get() {
        return [
          {
            text: this.$i18n.t("dashboard.num"),
            value: "row",
            sortable: false,
          },
          {
            text: this.$i18n.t("email.SendId"),
            value: "AccountId",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.name"),
            value: "Name",
            sortable: false,
          },
          {
            text: "หมายเลขประกาศ",
            value: "AnnounceNo",
            sortable: false,
          },
          {
            text: "ชื่อรายการประกาศ",
            value: "AnnounceName",
            align: "center",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.status"),
            value: "SendStatus",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.Note"),
            value: "ErrorMessage",
            sortable: false,
          },
        ];
      },
    },
    _SendId: {
      get() {
        return this.DataGroupConsent.SendId || "-";
      },
    },
  },
  watch: {
    show(val) {
      if (val == true) {
        this.DataList = this._detail;
        this.fn_setData();
      }
    },
  },
  mounted() {},
  methods: {
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    fn_setData() {
      for (var i in this.DataList) {
        this.DataList[i].row = parseInt(i) + 1;
      }
    },
    Fn_Close() {
      this.$emit("closeDialogDelete");
      window.location.reload();
    },
  },
};
</script>
<style scoped>
.noteStlye {
  width: 150px;
  word-wrap: break-word;
}
</style>
